<template>
  <b-row>
    <b-col md="12">
      <HeadCards />
    </b-col>

    <b-col md="6">
      <b-row>
        <b-col md="6">
          <AppSearchInput
            :placeholder="$t('generals.search')"
            @callback="onInput"
          />
        </b-col>
        <b-col
          v-if="GET_USER_PERMISSIONS.includes('user_management')"
          md="6"
        >
          <v-select
            v-model="filter.manager"
            label="title"
            class="bg-white flex-grow-1 ml-1"
            :placeholder="$t('kanban.manager')"
            :reduce="manager => manager.id"
            :options="clientsList"
          />
        </b-col>
      </b-row>
    </b-col>

    <b-col
      md="6"
      class="d-flex justify-content-end align-items-center"
    >
      <b-button
        v-if="GET_USER_PERMISSIONS.includes('sales_management')"
        v-b-modal.lid-modal
        variant="primary"
        size="md"
        class="d-flex"
      >
        <feather-icon
          icon="PlusIcon"
          size="15"
          class="mr-25"
        />
        {{ $t('generals.add') }}
      </b-button>
    </b-col>

    <b-col md="12">
      <DraggableCards
        ref="dragCards"
        :filter="filter"
      />
    </b-col>

    <LidModal @saveSuccess="saveSuccess" />
  </b-row>
</template>

<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import HeadCards from './components/HeadCards.vue'
import LidModal from './components/LidModal.vue'
import DraggableCards from './components/DragableCard.vue'
import AppSearchInput from '../Clients/components/AppSearchInput.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    HeadCards,
    VSelect,
    LidModal,
    DraggableCards,
    AppSearchInput,
  },
  data() {
    return {
      filter: {
        manager: '',
        search: '',
      },
    }
  },
  computed: {
    ...mapGetters('clients', ['getUsers']),
    ...mapGetters('kanban', ['getCrmStepsList']),
    ...mapGetters('users', ['GET_USER_PERMISSIONS']),
    clientsList() {
      return this.getUsers.results.map(user => ({
        title: user.first_name,
        id: user.id,
      }))
    },
    getLang() {
      return this.$i18n.locale || 'ru'
    },
  },
  async mounted() {
    await this.FETCH_CRM_STEPS()
    this.FETCH_USERS_LIST()
    this.filter.manager = null
  },
  methods: {
    ...mapActions('kanban', ['FETCH_CRM_STEPS', 'FETCH_KANBAN_CARDS_LIST']),
    ...mapActions('clients', ['FETCH_USERS_LIST']),
    onInput(text) {
      this.filter.search = text
    },
    saveSuccess() {
      this.FETCH_CRM_STEPS()
      this.$refs.dragCards.refresh()
    },
  },

}
</script>

<style lang="scss" scoped>
.steps {
    min-width: 100%;
    overflow: auto;
}
</style>
